export default __webpack_public_path__ + "static/media/home-profile-change.5bc36347.svg";